<script lang="ts">
export interface SplitterPanelProps extends ClassProps, RekaSplitterPanelProps {}
</script>

<script setup lang="ts">
import {
	SplitterPanel,
	useForwardPropsEmits,
	type SplitterPanelProps as RekaSplitterPanelProps,
	type SplitterPanelEmits,
} from "reka-ui";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";

const props = defineProps<SplitterPanelProps>();
const emit = defineEmits<SplitterPanelEmits>();

const delegatedProps = useDelegatedProps(props);

const forwarded = useForwardPropsEmits(delegatedProps, emit);
</script>

<template>
	<SplitterPanel :class="cn('flex *:grow', props.class)" v-bind="forwarded">
		<slot />
	</SplitterPanel>
</template>
